import moment from "moment";

const ANTTags = (doc, data, item, index) => {
    
    //ETIQUETA PADRE
    var ANT = doc.createElement("ANT");

     //Valor del anticipo  No puede ser superior al valor total de la factura (TOT_1)
     var ANT_1 = doc.createElement("ANT_1");
     ANT_1.innerHTML = parseInt(item.total);
     ANT.appendChild(ANT_1);

     //Moneda del valor del anticipo
     var ANT_2 = doc.createElement("ANT_2");
     ANT_2.innerHTML = "COP";;
     ANT.appendChild(ANT_2);

     //Fecha en que se pagó el anticipo Formato AAAA-MM-DD 
     var ANT_3 = doc.createElement("ANT_3");
     ANT_3.innerHTML = moment(item.fecha_recibo).format("YYYY-MM-DD"); 
     ANT.appendChild(ANT_3);

     //Hora en que se pagó el anticipo. Formato: HH:MM:SSdhh:mm,
     var ANT_4 = doc.createElement("ANT_4");
     ANT_4.innerHTML = moment(item.fecha_recibo).utc().format("HH:mm:ss");
     ANT.appendChild(ANT_4);

     //Identificación del pago 
     var ANT_5 = doc.createElement("ANT_5");
     //ANT_5.innerHTML = !!item.tipo_pago ? item.tipo_pago : "COPAGO";
	 ANT_5.innerHTML = "1";
     ANT.appendChild(ANT_5);

     //Fecha en la cual el pago fue recibido. Formato: AAAA-MM-DD
     var ANT_6 = doc.createElement("ANT_6");
     ANT_6.innerHTML = moment(item.fecha_recibo).format("YYYY-MM-DD");
     ANT.appendChild(ANT_6);

    //Instrucciones relativas al pago
     var ANT_7 = doc.createElement("ANT_7");
     ANT_7.innerHTML = !!item.tipo_pago ? item.tipo_pago : "COPAGO";
     ANT.appendChild(ANT_7);

    //concepto recaudo
     var ANT_8 = doc.createElement("ANT_8");
    switch (item.tipo_pago) {
		case "COPAGO":
            ANT_8.innerHTML = "01";
            break;
        case "CUOTA MODERADORA":
            ANT_8.innerHTML = "02";
            break;
		case "CUOTA DE RECUPERACIÓN":
            ANT_8.innerHTML = "03";
            break;
		case "OTROS":
		  return "05";
        case "PARTICULAR":
            ANT_8.innerHTML = "05";
            break;
        case "PARTICULAR MEDICINA PREPAGADA":
            ANT_8.innerHTML = "03";
            break;
        case "POLIZA":
            ANT_8.innerHTML = "03";
            break;
		case "REG. ESPECIAL":
		  return "05";
		case "SOAT":
		  return "05";
		case "NO APLICA":
		  return "05";
        default:
            ANT_8.innerHTML = "05";
            break;
    }
    ANT.appendChild(ANT_8) 

    return ANT;
}

export default ANTTags;